



















import { Component, Mixins, Prop } from 'vue-property-decorator';
import { Component as LoadingSpinner } from '@/components/spinners';
import { Warning, Info } from '@/pages/profile/components';
import Infotext from '@/components/parts/infotext';
import ViewsProps from '@/pages/profile/modules/remote-edu/mixins/viewsProps';
import { Top } from '../components';
import AppButtonNew from '@/uikit/components/AppButtonNew/AppButtonNew.vue';
import InfoSferum from '@/pages/profile/components/infoSferum/InfoSferum.vue';
import { Paginator } from '@/components/parts/pagination';

@Component({
  components: {
    InfoSferum,
    AppButtonNew,
    Top,
    LoadingSpinner,
    Infotext,
    Warning,
    Info,
    Paginator,
  },
})
export default class Webinars extends Mixins(ViewsProps) {
  get isSferumModule(): boolean {
    return this.$store.getters.hasSferumModule;
  }
  @Prop({ type: String, default: 'На данный момент вебинары не проводятся.' })
  errorText: string;

  @Prop({ type: Object, required: false })
  paginatorData: any;
  get pagesCount(): number {
    const count = this.paginatorData.filtered;
    const limit = this.paginatorData.limit;
    return limit ? Math.ceil(count / limit) : 0;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/remote-edu/webinars/Webinars.vue